import * as Utilities from '../forum/utilities';
import { Modal } from 'bootstrap';
const _global = (window /* browser */ || global /* node */);
function setSearchPageNumber(pageSize, pageNumber, total) {
    const pages = Math.ceil(total / pageSize), pagerHolderTop = document.getElementById('SearchResultsPagerTop'), pagerHolderBottom = document.getElementById('SearchResultsPagerBottom'), pagination = document.createElement('ul'), paginationNavTop = document.createElement('nav'), paginationNavBottom = document.createElement('nav');
    paginationNavTop.setAttribute('aria-label', 'Search Page Results');
    paginationNavBottom.setAttribute('aria-label', 'Search Page Results');
    pagination.classList.add('pagination');
    Utilities.empty(pagerHolderTop);
    Utilities.empty(pagerHolderBottom);
    if (pageNumber > 0) {
        const page = document.createElement('li');
        page.classList.add('page-item');
        page.innerHTML =
            `<a href="javascript:getSearchResultsData(${pageNumber - 1})" class="page-link"><i class="fas fas fa-angle-left" aria-hidden="true"></i></a>`;
        pagination.appendChild(page);
    }
    let start = pageNumber - 2;
    let end = pageNumber + 3;
    if (start < 0) {
        start = 0;
    }
    if (end > pages) {
        end = pages;
    }
    if (start > 0) {
        let page = document.createElement('li');
        page.classList.add('page-item');
        page.innerHTML = `<a href="javascript:getSearchResultsData(${0});" class="page-link">1</a>`;
        pagination.appendChild(page);
        page = document.createElement('li');
        page.classList.add('page-item');
        page.classList.add('disabled');
        page.innerHTML = '<a class="page-link" href="#" tabindex="-1">...</a>';
        pagination.appendChild(page);
    }
    for (let i = start; i < end; i++) {
        if (i === pageNumber) {
            const page = document.createElement('li');
            page.classList.add('page-item');
            page.classList.add('active');
            page.innerHTML = `<span class="page-link">${i + 1}</span>`;
            pagination.appendChild(page);
        }
        else {
            const page = document.createElement('li');
            page.classList.add('page-item');
            page.innerHTML = `<a href="javascript:getSearchResultsData(${i});" class="page-link">${i + 1}</a>`;
            pagination.appendChild(page);
        }
    }
    if (end < pages) {
        let page = document.createElement('li');
        page.classList.add('page-item');
        page.classList.add('disabled');
        page.innerHTML = '<a class="page-link" href="#" tabindex="-1">...</a>';
        pagination.appendChild(page);
        page = document.createElement('li');
        page.classList.add('page-item');
        page.innerHTML = `<a href="javascript:getSearchResultsData(${pages - 1})" class="page-link">${pages}</a>`;
        pagination.appendChild(page);
    }
    if (pageNumber < pages - 1) {
        const page = document.createElement('li');
        page.classList.add('page-item');
        page.innerHTML =
            `<a href="javascript:getSearchResultsData(${pageNumber + 1})" class="page-link"><i class="fas fas fa-angle-right" aria-hidden="true"></i></a>`;
        pagination.appendChild(page);
    }
    paginationNavTop.appendChild(pagination);
    paginationNavBottom.innerHTML = paginationNavTop.innerHTML;
    if (pagerHolderTop) {
        pagerHolderTop.appendChild(paginationNavTop);
    }
    if (pagerHolderBottom) {
        pagerHolderBottom.appendChild(paginationNavBottom);
    }
}
function getSearchResultsData(pageNumber) {
    const searchInput = document.querySelector('.searchInput').value;
    const searchInputUser = document.querySelector('.searchUserInput').value;
    const searchInputTag = document.querySelector('.searchTagInput').value;
    const placeHolder = document.getElementById('SearchResultsPlaceholder');
    const ajaxUrl = '/api/Search/GetSearchResults';
    const loadModal = new Modal('#loadModal');
    const useDisplayName = document.querySelector('.searchUserInput').dataset.display === 'True';
    // filter options
    const pageSize = parseInt(document.querySelector('.resultsPage').value);
    const titleOnly = document.querySelector('.titleOnly').value;
    const searchWhat = document.querySelector('.searchWhat').value;
    const minimumLength = placeHolder.dataset.minimum;
    // Forum Filter
    const searchForum = document.getElementById('Input_ForumListSelected').value === ''
        ? 0
        : parseInt(document.getElementById('Input_ForumListSelected').value);
    let searchText = '';
    if (searchInput.length && searchInput.length >= parseInt(minimumLength) ||
        searchInputUser.length && searchInputUser.length >= parseInt(minimumLength) ||
        searchInputTag.length && searchInputTag.length >= parseInt(minimumLength)) {
        let replace;
        if (searchInput.length && searchInput.length >= parseInt(minimumLength)) {
            if (titleOnly === '1') {
                // ADD Topic Filter
                if (searchWhat === '0') {
                    // Match all words
                    replace = searchInput;
                    searchText += ` Topic: (${replace.replace(/(^|\s+)/g, '$1+')})`;
                }
                else if (searchWhat === '1') {
                    // Match Any Word
                    searchText += ` Topic: ${searchInput}`;
                }
                else if (searchWhat === '2') {
                    // Match Exact Phrase
                    searchText += ` Topic:"${searchInput}"`;
                }
            }
            else {
                if (searchWhat === '0') {
                    // Match all words
                    replace = searchInput;
                    searchText += `(${replace.replace(/(^|\s+)/g, '$1+')})`;
                }
                else if (searchWhat === '1') {
                    // Match Any Word
                    searchText += `${searchInput}`;
                }
                else if (searchWhat === '2') {
                    // Match Exact Phrase
                    searchText += `"${searchInput}"`;
                }
            }
        }
        if (searchInputUser.length && searchInputUser.length >= parseInt(minimumLength)) {
            const author = useDisplayName ? 'AuthorDisplay' : 'Author';
            if (searchText.length)
                searchText += ' ';
            if (searchInput.length) {
                searchText += `AND ${author}:${searchInputUser}`;
            }
            else {
                searchText = `+${author}:${searchInputUser}`;
            }
        }
        if (searchInputTag.length && searchInputTag.length >= parseInt(minimumLength)) {
            if (searchText.length)
                searchText += ' ';
            if (searchInput.length) {
                searchText += `AND TopicTags:${searchInputTag}`;
            }
            else {
                searchText = `+TopicTags:${searchInputTag}`;
            }
        }
        const searchTopic = {
            ForumId: searchForum,
            PageSize: pageSize,
            Page: pageNumber,
            SearchTerm: searchText
        };
        Utilities.empty(placeHolder);
        // show loading screen 
        loadModal.show();
        fetch(ajaxUrl, {
            method: 'POST',
            body: JSON.stringify(searchTopic),
            headers: {
                Accept: 'application/json',
                "Content-Type": 'application/json;charset=utf-8',
                "RequestVerificationToken": document.querySelector('input[name="__RequestVerificationToken"]').value
            }
        }).then(res => res.json()).then(data => {
            var _a;
            (_a = document.getElementById('loadModal')) === null || _a === void 0 ? void 0 : _a.addEventListener('shown.bs.modal', () => {
                loadModal.hide();
            });
            const posted = placeHolder.dataset.posted || '';
            const by = placeHolder.dataset.by || '';
            const lastPost = placeHolder.dataset.lastpost || '';
            const topic = placeHolder.dataset.topic || '';
            if (data.searchResults.length === 0) {
                loadModal.hide();
                const noText = placeHolder.dataset.notext || '';
                const div = document.createElement('div');
                div.innerHTML = `<div class="alert alert-warning text-center mt-3" role="alert">${noText}</div>`;
                placeHolder.appendChild(div);
                Utilities.empty(document.getElementById('SearchResultsPagerTop'));
                Utilities.empty(document.getElementById('SearchResultsPagerBottom'));
            }
            else {
                loadModal.hide();
                data.searchResults.forEach((dataItem) => {
                    const item = document.createElement('div');
                    let tags = ' ';
                    if (dataItem.topicTags) {
                        const topicTags = dataItem.topicTags.split(',');
                        topicTags.forEach((d) => {
                            tags += `<span class='badge text-bg-secondary me-1'><i class='fas fa-tag me-1'></i>${d}</span>`;
                        });
                    }
                    item.innerHTML = `
                <div class="row">
                    <div class="col">
                        <div class="card border-0 w-100 mb-3">
                            <div class="card-header bg-transparent border-top border-bottom-0 px-0 pb-0 pt-4 topicTitle">
                                <h5>
                                    <a title="${topic}" href="${dataItem.topicUrl}">${dataItem.topic}</a>&nbsp;
                                    <a title="${lastPost}" href="${dataItem.messageUrl}"><i class="fas fa-external-link-alt"></i></a>
                                    <small class="text-body-secondary">(<a href="${dataItem.forumUrl}">${dataItem
                        .forumName}</a>)</small>
                                </h5>
                            </div>
                            <div class="card-body px-0">
                                <h6 class="card-subtitle mb-2 text-body-secondary">${dataItem.description}</h6>
                                <p class="card-text messageContent">${dataItem.message}</p>
                            </div>
                            <div class="card-footer bg-transparent border-top-0 px-0 py-2">
                                <small class="text-body-secondary">
                                    <span class="fa-stack">
                                        <i class="fa fa-calendar-day fa-stack-1x text-secondary"></i>
                                        <i class="fa fa-clock fa-badge text-secondary"></i>
                                    </span>
                                    ${posted} ${dataItem.posted} <i class="fa fa-user text-secondary"></i>${by} ${useDisplayName ? dataItem.userDisplayName : dataItem.userName}${tags}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>`;
                    placeHolder.appendChild(item);
                });
                setSearchPageNumber(pageSize, pageNumber, data.totalRecords);
                // Gallery
                document.querySelectorAll('[data-toggle="lightbox"]').forEach(element => {
                    element.addEventListener('click', _global.bootstrap.Lightbox.initialize);
                });
            }
        }).catch((error) => {
            console.log(error);
            document.getElementById('SearchResultsPlaceholder').style.display = 'none';
            placeHolder.textContent = error;
        });
    }
}
//////////////
const searchInput = document.querySelector('.searchInput');
searchInput.addEventListener('keypress', (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        const pageNumberSearch = 0;
        getSearchResultsData(pageNumberSearch);
    }
});
document.addEventListener('DOMContentLoaded', () => {
    var url = new URL(window.location.href);
    if (url.searchParams.has('search') ||
        url.searchParams.has('forum') ||
        url.searchParams.has('postedBy') ||
        url.searchParams.has('tag')) {
        getSearchResultsData(0);
    }
});
_global.getSearchResultsData = getSearchResultsData;
